(function () {
  var SHIPPING_CLASS = 'ww-cart-shipping';
  var FREE_THRESHOLD_CENTS = {
    CA: 8500,
    DEFAULT: 13600
  };
  var RATES = {
    US: { amount: 2100, currency: 'USD' },
    CA: { amount: 1399, currency: 'CAD' }
  };
  var updating = false;

  function getCountry() {
    if (window.Shopify && Shopify.country) return String(Shopify.country).toUpperCase();
    return '';
  }

  function getActiveCurrency() {
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return String(Shopify.currency.active).toUpperCase();
    }
    return '';
  }

  function formatMoney(cents, currency) {
    var amount = (Number(cents) || 0) / 100;
    var localeTag = 'en';
    if (currency === 'USD') localeTag = 'en-US';
    if (currency === 'CAD') localeTag = 'en-CA';

    try {
      return new Intl.NumberFormat(localeTag, {
        style: 'currency',
        currency: currency
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function getFreeThresholdCents(country) {
    return country === 'CA' ? FREE_THRESHOLD_CENTS.CA : FREE_THRESHOLD_CENTS.DEFAULT;
  }

  function getShippingDisplay(cart) {
    var total = cart && typeof cart.total_price === 'number' ? cart.total_price : 0;
    var country = getCountry();
    var rate = RATES[country];

    if (total >= getFreeThresholdCents(country)) {
      return { label: 'Shipping:', value: 'Free', isFree: true };
    }

    if (!rate) {
      return { label: 'Shipping:', value: 'Calculated at checkout', isFree: false };
    }

    var currency = getActiveCurrency() === rate.currency ? getActiveCurrency() : rate.currency;
    return {
      label: 'Shipping:',
      value: formatMoney(rate.amount, currency),
      isFree: false
    };
  }

  function ensureShippingRow() {
    var subtotal = document.querySelector('.cd-cart-subtotal:not(.' + SHIPPING_CLASS + ')');
    if (!subtotal) return null;

    var existing = document.querySelector('.' + SHIPPING_CLASS);
    if (existing && existing.previousElementSibling === subtotal) return existing;

    if (existing) existing.remove();

    var row = document.createElement('div');
    row.className = 'cd-cart-subtotal cd-cart-shipping ' + SHIPPING_CLASS;
    row.setAttribute('aria-live', 'polite');
    updating = true;
    subtotal.insertAdjacentElement('afterend', row);
    updating = false;
    return row;
  }

  function renderShipping(cart) {
    var row = ensureShippingRow();
    if (!row) return;

    var display = getShippingDisplay(cart);
    var html =
      '<span class="cd-cart-shipping-label">' +
      display.label +
      '</span>' +
      '<span class="cd-cart-subtotal-amount cd-cart-shipping-amount' +
      (display.isFree ? ' is-free' : '') +
      '">' +
      display.value +
      '</span>';

    if (row.dataset.wwShippingHtml === html) return;

    updating = true;
    row.dataset.wwShippingHtml = html;
    row.innerHTML = html;
    updating = false;
  }

  function fetchAndRender() {
    if (typeof window.CD_GETCARTDATA === 'function') {
      try {
        var liveCart = window.CD_GETCARTDATA();
        if (liveCart && typeof liveCart.total_price === 'number') {
          renderShipping(liveCart);
          return;
        }
      } catch (e) {}
    }

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderShipping(cart); })
      .catch(function () {});
  }

  var timer;
  function debouncedRender() {
    if (updating) return;
    clearTimeout(timer);
    timer = setTimeout(fetchAndRender, 150);
  }

  function watchDrawer(target) {
    new MutationObserver(debouncedRender).observe(target, {
      childList: true,
      subtree: true
    });
  }

  var style = document.createElement('style');
  style.textContent =
    '.' + SHIPPING_CLASS + '{' +
      'display: flex !important;' +
      'justify-content: space-between;' +
      'align-items: center;' +
      'width: 100%;' +
      'box-sizing: border-box;' +
      'margin: 0;' +
      'font: inherit;' +
      'font-weight: inherit;' +
      'color: inherit;' +
      'line-height: inherit;' +
    '}' +
    '.' + SHIPPING_CLASS + ' .cd-cart-shipping-label,' +
    '.' + SHIPPING_CLASS + ' .cd-cart-shipping-amount{' +
      'font: inherit;' +
      'font-weight: inherit;' +
      'color: inherit;' +
    '}';
  document.head.appendChild(style);

  var drawerRoot = document.getElementById('cart-drawer-app');
  if (drawerRoot) {
    watchDrawer(drawerRoot);
    fetchAndRender();
  } else {
    new MutationObserver(function (_, obs) {
      var t = document.getElementById('cart-drawer-app');
      if (t) {
        obs.disconnect();
        watchDrawer(t);
        fetchAndRender();
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.addEventListener('cartix:cartUpdated', function (event) {
    if (event && event.detail && event.detail.cart) {
      renderShipping(event.detail.cart);
    } else {
      fetchAndRender();
    }
  });

  document.addEventListener('theme:cartchanged', debouncedRender);
})();
